// @flow
import {css} from "styled-components";

const onePartOfRow = 100 / 12;

export const Col1 = css`
    width: ${onePartOfRow}%;
`;

export const Col2 = css`
    width: ${onePartOfRow * 2}%;
`;

export const Col3 = css`
    width: ${onePartOfRow * 3}%;
`;

export const Col4 = css`
    width: ${onePartOfRow * 4}%;
`;

export const Col5 = css`
    width: ${onePartOfRow * 5}%;
`;

export const Col6 = css`
    width: ${onePartOfRow * 6}%;
`;

export const Col7 = css`
    width: ${onePartOfRow * 7}%;
`;

export const Col8 = css`
    width: ${onePartOfRow * 8}%;
`;

export const Col9 = css`
    width: ${onePartOfRow * 9}%;
`;

export const Col10 = css`
    width: ${onePartOfRow * 10}%;
`;

export const Col11 = css`
    width: ${onePartOfRow * 11}%;
`;

export const Col12 = css`
    width: ${onePartOfRow * 12}%;
`;


// WEBPACK FOOTER //
// ./src/Components/Columns.js